import React from "react";
import { CreditCard, User, MapPin } from "lucide-react";

const BillingInfoTab = ({
  billingAddress = {},
  user = {},
  invoiceNumber = "",
}) => {
  return (
    <div className="p-8">
      <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
        <CreditCard className="w-6 h-6 text-purple-600" />
        Billing Information
      </h2>
      <div className="p-6 space-y-6">
        <div className="grid md:grid-cols-2 gap-4">
          <div className="bg-green-50 p-4 rounded-xl border">
            <div className="flex gap-4 items-start">
              <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center text-white">
                <User />
              </div>
              <div>
                <h3 className="font-semibold text-lg">Customer</h3>
                <p>
                  {user?.firstName} {user?.lastName}
                </p>
                <p className="text-sm text-green-600">{user?.email}</p>
              </div>
            </div>
          </div>

          <div className="bg-orange-50 p-4 rounded-xl border">
            <div className="flex gap-4 items-start">
              <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center text-white">
                <MapPin />
              </div>
              <div>
                <h3 className="font-semibold text-lg">Billing Address</h3>
                <p className="font-medium">{billingAddress?.name || "-"}</p>
                <p>{billingAddress?.address1}</p>
                {billingAddress?.address2 && <p>{billingAddress?.address2}</p>}
                {/* <p>
                  {billingAddress?.city}, {billingAddress?.state}{" "}
                  {billingAddress?.postalCode}
                </p>
                <p>{billingAddress?.country}</p>
                <p className="font-semibold text-gray-900">
                  {billingAddress?.label || "-"}
                </p> */}
                <p className="text-sm text-orange-600 mt-1">
                  {billingAddress?.email}
                </p>
                <p className="text-sm text-orange-600">
                  {billingAddress?.phone}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-purple-50 p-4 rounded-xl border flex gap-4 items-center">
          <div className="w-10 h-10 bg-purple-500 text-white rounded-full flex items-center justify-center">
            <CreditCard />
          </div>
          <div>
            <h3 className="font-semibold">Invoice Number</h3>
            <p className="font-mono">{invoiceNumber || "N/A"}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingInfoTab;
